<template>
  <div class="responsive-table-holder">
    <table class="responsive-table report-table">
      <thead>
        <tr>
          <th
            v-for="col in columns"
            :key="col"
            @click="sortTable(col)"
          >
            {{ col }}
            <font-awesome-icon
              v-if="col"
              :icon="['fas', 'sort']"
              class="icon alt"
            />
            <span
              v-if="col && col == sortColumn"
              :class="ascending ? 'active-down' : 'active-up'"
            >
              <font-awesome-icon
                :icon="['fas', 'sort-down']"
                class="icon alt"
              />
              <font-awesome-icon
                :icon="['fas', 'sort-up']"
                class="icon alt"
              />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.Recipient"
        >
          <td
            v-for="col in columns"
            :key="row[col]"
          >
            <a
              v-if="col === 'Email'"
              :href="`mailto:${row[col]}`"
            >
              {{ row[col] }}
            </a>

            <span v-else>
              {{ row[col] }}
            </span>

            <!--This label recreates the table header in the modal display-->
            <label
              class="d-block d-md-none"
            >
              {{ col }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserTable',
  props: {
    items: {
      type: Array,
    },
  },
  data: () => ({
    ascending: false,
    sortColumn: '',
  }),
  computed: {
    rows() {
      if (!this.items || !this.items.length) {
        return [];
      }

      return this.items.map(i => {
        return {
          id: i.id,
          Sender: i.creator_name || '',
          Recipient: i.email || '',
          Status: i.status || '',
        }
      }).sort((a, b) => {
        if (a[this.sortColumn] > b[this.sortColumn]) {
          return this.ascending ? 1 : -1;
        } if (a[this.sortColumn] < b[this.sortColumn]) {
          return this.ascending ? -1 : 1;
        }
        return 0;
      });;
    },
    columns() {
      if (this.rows.length === 0) {
        return [];
      }
      return Object.keys(this.rows[0]).filter(k => k !== 'id');
    },
  },
  methods: {
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.responsive-table-holder {
  margin-top: 15px;
}

.responsive-table {
  border: none;
  background: white;

  &.report-table {
    tbody {
      tr {
        td {
          font-size: 15px;

          &:first-of-type {
            @media (min-width: $xl-min) {
              white-space: nowrap;
            }
          }
        }
      }

      .status {
        white-space: nowrap;
        min-width: 140px;

        i,
        svg {
          margin-right: 6px;
          opacity: 0.5;

          &.fa-times-circle {
            color: $red;
            opacity: 1;
          }

          &.fa-check-circle {
            color: $green;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
